const initFooter = () => {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-footer-menu-btn]');

    if (btn) {
      e.preventDefault();
      const footerMenu = document.querySelector('[data-footer-menu]');
      footerMenu.classList.toggle('is-active');
    }
  });
};

export {initFooter};
